import { useState, useEffect } from 'react'
import { useQuery } from 'react-query'
import apiService from '../services/api'
import AdminLayout from '../components/AdminLayout'
import { Mail, Search } from 'lucide-react'

const AdminMails = () => {
  const [search, setSearch] = useState('')
  const [selected, setSelected] = useState(null)
  const { data, refetch, isLoading } = useQuery(
    ['admin-mails', search],
    () => apiService.get('/emails/messages', { params: { search, limit: 50 } }).then(r => r.data),
    { keepPreviousData: true, refetchInterval: 5000, refetchOnWindowFocus: false }
  )
  useEffect(() => { const t = setTimeout(() => refetch(), 300); return () => clearTimeout(t) }, [search, refetch])
  const messages = data?.messages || []

  return (
    <AdminLayout title="Administration" subtitle="Mails">
          <div className="card mb-6">
            <div className="flex items-center">
              <Search className="h-4 w-4 text-gray-500 mr-2" />
              <input className="input-field" placeholder="Rechercher nom, email, sujet, message" value={search} onChange={(e)=>setSearch(e.target.value)} />
            </div>
          </div>
          <div className="card">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="text-left py-3 px-4">Date</th>
                    <th className="text-left py-3 px-4">Nom</th>
                    <th className="text-left py-3 px-4">Email</th>
                    <th className="text-left py-3 px-4">Sujet</th>
                    <th className="text-left py-3 px-4">Message</th>
                    <th className="text-left py-3 px-4">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr><td colSpan="5" className="py-12 text-center text-gray-600">Chargement…</td></tr>
                  ) : messages.length === 0 ? (
                    <tr><td colSpan="5" className="py-12 text-center text-gray-600">Aucun message</td></tr>
                  ) : (
                    messages.map(m => (
                      <tr key={m.id} className="border-b border-gray-200 hover:bg-gray-50">
                        <td className="py-3 px-4">{new Date(m.created_at).toLocaleString('fr-FR')}</td>
                        <td className="py-3 px-4">{m.name}</td>
                        <td className="py-3 px-4">{m.email}</td>
                        <td className="py-3 px-4">{m.subject || '-'}</td>
                        <td className="py-3 px-4 max-w-xl truncate">{m.message}</td>
                        <td className="py-3 px-4">
                          <button
                            className="text-blue-600 hover:text-blue-800 text-sm underline"
                            onClick={() => setSelected(m)}
                          >
                            Voir
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {selected && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg p-6 max-w-2xl w-full mx-4">
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{selected.subject || 'Message'}</h3>
                <div className="text-sm text-gray-600 mb-4">
                  <div><strong>De:</strong> {selected.name} &lt;{selected.email}&gt; {selected.phone ? `(${selected.phone})` : ''}</div>
                  <div><strong>Reçu:</strong> {new Date(selected.created_at).toLocaleString('fr-FR')}</div>
                </div>
                <div className="whitespace-pre-wrap text-gray-800 border rounded p-4 bg-gray-50 max-h-96 overflow-auto">
                  {selected.message}
                </div>
                <div className="flex justify-end gap-3 mt-6">
                  <button className="px-4 py-2 text-gray-600 hover:text-gray-800" onClick={() => setSelected(null)}>
                    Fermer
                  </button>
                </div>
              </div>
            </div>
          )}
    </AdminLayout>
  )
}

export default AdminMails


